/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchHasPasskeyRegistered } from '../api';
import {
  passkeyStatusFailed,
  passkeyStatusRequest,
  passkeyStatusSuccess,
} from '../reducer/passkeyStatusSlice';

export function* passkeyStatusSaga(
  action: any
): Generator<any, void, unknown> {
  const { accountId, customerId } = action.payload;
  try {
    const response: any = yield call(
      fetchHasPasskeyRegistered,
      accountId,
      customerId
    );
    const isSuccessStatus =
      response?.status === 200 || response?.status === '200';

    if (isSuccessStatus) {
      const registeredValue =
        response?.data?.isRegistered ?? response?.data?.isregistered;
      const isRegistered =
        registeredValue === true || registeredValue === 'true';
      yield put(passkeyStatusSuccess(isRegistered));
    } else {
      const { status, detail, errorCode, body } = response ?? {};
      yield put(
        passkeyStatusFailed({
          statusCode: status ?? '500',
          error: {
            errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
            msg: detail ?? body ?? 'An unknown error occurred.',
            statusCode: status ?? '500',
          },
        })
      );
    }
  } catch (error: any) {
    const {
      status = '500',
      errorCode = 'UNKNOWN_ERROR',
      detail = 'An unknown error occurred.',
    } = error?.data ?? error ?? {};
    yield put(
      passkeyStatusFailed({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}

export function* watchPasskeyStatusSaga() {
  yield takeLatest(passkeyStatusRequest.type, passkeyStatusSaga);
}
